<template>
  <div>
    <act-popup :active.sync="active" ref="actPopup" @save="save" @delete="deleteAct"/>
  </div>
</template>

<script>
  import ActPopup        from "@/components/calculated-program/acts/ActPopup_";
  import notifyHttpError from "@/mixins/notifyHttpError";

  export default {
    name: "ActPopupChange",
    mixins:     [notifyHttpError],
    components: {
      ActPopup
    },
    data() {
      return {
        active: false,
        id: null,
      }
    },
    computed: {
      selectedHouseId(){
        return this.$store.getters['appUser/selectedHouse'].id;
      },
    },
    methods: {
      open(id){
        try{
          this.$refs.actPopup.isLoading = true;
          this.active = true;
          this.id = id;
          this.$nextTick(async () => {
            let {data} = await this.$http.get('acts', {
              params: {
                buildings_id: this.selectedHouseId,
                id: id
              }
            });

            let actDb = data.length ? data[0] : {};
            let act = {
              id: actDb.id,
              parameters: actDb.parameters,
              entity_type: null,
              entity_id: null,
              main: {
                act_type: actDb.act_type,
                buildings_id: actDb.buildings_id,
                status: actDb.status,
                comment: actDb.comment,
                errors: actDb.errors !== null ? JSON.parse(actDb.errors) : null,
              },
              files: {
                uploaded: [],
                deleted: [],
                fromStorage: actDb.attached_files
              }
            };
            let objects = [];

            if(actDb.building){
              objects = objects.concat(...actDb.building.map(b => ({
                icon: 'HomeIcon',
                colorClass: '',
                text: b.address
              })));
            }

            if(actDb.apartment){
              objects = objects.concat(...actDb.apartment.map(a => ({
                icon: 'DoorIcon',
                colorClass: '',
                text: `Лицевой счет №${a.account_number}`
              })));
            }

            if(actDb.device){
              objects = objects.concat(...actDb.device.map(device => ({
                icon: this.$store.getters['common/devices/typeById'](device.type).icon,
                colorClass: this.$store.getters['common/devices/typeById'](device.type).icon_color ? 'text-' + this.$store.getters['common/devices/typeById'](device.type).icon_color : '',
                text: `${this.$store.getters['common/devices/typeById'](device.type).name} №${device.factory_number ? device.factory_number : 'Без номера'}`
              })));
            }
            act.objects = objects;

            if(actDb.building){
              act.building = actDb.building[0];
              act.entity_type = 'building';
            }

            if(actDb.apartment){
              act.apartment = actDb.apartment[0];
              act.entity_type = 'apartment';
            }

            if(actDb.device){
              act.device = actDb.device[0];
              act.entity_type = 'device';
            }

            act.building = actDb.building ? ([4].includes(actDb.status) ?  actDb.building : actDb.building[0]) : null;
            act.apartment = actDb.apartment ? ([4].includes(actDb.status) ?  actDb.apartment : actDb.apartment[0] ) : null;
            act.object = actDb.device ? ([4].includes(actDb.status) ?  actDb.device : actDb.device[0] ): null;
            this.$refs.actPopup.setAct(act);
          });
        }
        catch(e){
          console.error(e);
        }

      },
      async save({act, isFinal}){
        try{
          //Удаление строк из таблицы
          const deletedTablesRowsPromises = Object.entries(act.deletedTableLines).map(([field, row]) => {
            return new Promise(async resolve => {
              let deleteTableRowBody = {
                buildings_id: act.main.buildings_id,
                acts_id: act.id,
                table_field: field,
                table_line_id: row
              };
              let {data} = await this.$http.delete('acts_table_line', {
                params: deleteTableRowBody,
              });
              resolve();
            });
          });
          await Promise.all(deletedTablesRowsPromises);

          //Загрузка файлов
          if(act.files.uploaded.length){
            let uploadFilesBody = new FormData();
            uploadFilesBody.append('buildings_id', act.main.buildings_id);
            uploadFilesBody.append('acts_id', act.id);

            for(let i = 0; i < act.files.uploaded.length; i++){
              let file = act.files.uploaded[i];
              uploadFilesBody.append(`act_files[${i}]`, file);
            }

            let {data} = await this.$http.post('act_files', uploadFilesBody);
          }

          //Удаление файлов
          if(act.files.deleted.length){
            let deletedFilesBody = {
              buildings_id: act.main.buildings_id,
              acts_id: act.id,
              files_ids: act.files.deleted
            };
            let {data} = await this.$http.delete('act_files', {
              params: deletedFilesBody
            });
          }

          //Обновление акта
          let updateActBody = {
            id: act.id,
            buildings_id: act.main.buildings_id,
            comment: act.main.comment,
            parameters: JSON.stringify(act.parameters),
            entity_type: act.entity_type,
            entity_id: act.entity_id,
          };

          if(isFinal){
            updateActBody.is_final = isFinal;
          }

          let {data} = await this.$http.put('acts/'+act.id, updateActBody);
          this.open(data.id);
          this.$vs.notify({color: 'success', title: 'Успешное сохранение', text: 'Акт изменен'});
          this.$emit('update-act');

        }
        catch(e){
          this.notifyHttpError(e);
        }


      },
      async deleteAct({id, recreate}){
        try{
          let {data} = await this.$http.delete('acts/'+id, {
            params: {
              buildings_id: this.selectedHouseId,
              id: id,
              recreate: recreate
            }
          });

          if(data.message === 'successfully canceled'){
            this.$vs.notify({color: 'success', title: 'Успешное удаление', text: 'Акт отменен'});
            this.$emit('update-act');
            this.active = false;
          }
          else if(data.message === 'successfully deleted'){
            this.$vs.notify({color: 'success', title: 'Успешное удаление', text: 'Акт удален'});
            this.$emit('update-act');
            this.active = false;
          }
          else if(data.message === 'successfully reverted'){
            this.$vs.notify({color: 'success', title: 'Успешное отмена', text: 'Акт отменен'});
            this.$emit('update-act');
            this.active = false;

            if(recreate){
              this.open(id);
            }
          }
        }
        catch(e){
          if (e.response) {
            if (e.response.status === 403 || e.response.status === 406) {
              this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
            }
            else if(e.response.status === 409){
              this.$vs.notify({color: 'danger', title: 'Данный акт нельзя откатить', text: 'Превышен лимит удаления акта(3 дня)'});
            }
            else {
              this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
            }
          } else {
            this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
          }
        }
      }
    }
  }
</script>
